import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/tailwind.css';
import './assets/tailwind.css';
import vClickOutside from 'v-click-outside';

const app = createApp(App);
app.use(store);
app.use(router);
app.use(vClickOutside);
app.mount('#app');
